export default {
  SET_PAYMENTS: function (state, payloads) {
    state.payments = payloads;
  },
};
